import { Col, Flex, Row } from "antd";
import React, { useEffect, useState } from "react";
import CardComponent from "@/components/card";
import IconSessionName from "@/components/icons/IconSessionName";
import IconCalender from "@/components/icons/IconCalender";
import IconSessionTime from "@/components/icons/IconSessionTime";
import ButtonComponent from "@/components/button/Button";
import "@/styles/components/sessionCardHoc.scss";
import { useNavigate } from "react-router-dom";
import { getBookedSessions } from "@/services/users/getBookedSessions";
import Slider from "react-slick";
import { useDispatch } from "react-redux";
import { setIsMiniDashboardOpen } from "@/reducers/commonSlice";
import { convertToLocalTime } from "@/helpers";
import { getCountryTimeZone } from "@/helpers/getCountryZone";

const settings = {
  infinite: false,
  dots: true,
  arrows: false,
  slidesToShow: 1,
};

const SessionCard = ({ item, handleJoinSession }) => {
  const [timezone, setTimezone] = useState();

  useEffect(() => {
    setTimezone(getCountryTimeZone());
  }, []);

  return (
    <div className="session-card">
      <CardComponent>
        <Flex gap={"0.5rem"} vertical>
          <Flex justify="space-between" align="center">
            <div className="body-b4 text-grey">Session with</div>
            {/* <ButtonComponent
              shape="circle"
              varient="primary"
              size="small"
              danger
              icon={<IconCross color="#fdfefe" />}
            /> */}
          </Flex>

          <Flex gap={"0.5rem"} align="center">
            <div className="profileImg">
              <img src="/assets/images/profile.svg" alt="" />
            </div>
            <div className="text-black body-b2">{item.studentName}</div>
          </Flex>

          <Flex gap={"0.5rem"} align="center" className="body-b3">
            <IconSessionName />
            <span className="text-grey">Session Name:</span>
            <span className="text-black body-b2">{item.name}</span>
          </Flex>

          <Flex gap={"0.5rem"} align="center" className="body-b3">
            <IconCalender />
            <span className="text-grey">Date:</span>
            <span className="text-black">{item.date}</span>
          </Flex>

          <Flex gap={"0.5rem"} align="center" className="body-b3">
            <IconSessionTime />
            <span className="text-grey">Time:</span>
            <span className="text-black">
              {item.time} {timezone ? `(${timezone})` : ""}
            </span>
          </Flex>

          <ButtonComponent
            varient="success"
            label="Start Session"
            onClick={() => handleJoinSession(item.id)}
          ></ButtonComponent>
        </Flex>
      </CardComponent>
    </div>
  );
};
const SessionCardHoc = ({ isDrawer = false }) => {
  const [sessionData, setSessionData] = useState([]);
  const [isCarousal, setIsCarousel] = useState(isDrawer);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getBookedSessions()
      .then((res) => {
        const updatedData = res?.map((x) => {
          return {
            ...x,
            ...convertToLocalTime(x.date, x.time),
          };
        });
        setSessionData(updatedData);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleJoinSession = (id) => {
    navigate(`/guide/lobby/${id}`);
  };

  const handleResize = () => {
    if (window.innerWidth <= 425) {
      console.log("first");
      setIsCarousel(true);
    } else {
      if (!isDrawer) {
        setIsCarousel(false);
      }
    }
  };

  useEffect(() => {
    handleResize();
  }, [window.innerWidth]);

  return (
    <div className="sessionhoc" data-session-count={sessionData?.length ?? 0}>
      <Flex
        align="center"
        justify="space-between"
        className="title-wrapper"
        style={{ marginTop: isDrawer ? "10px" : "" }}
      >
        <div className="text-grey body-b3">Today’s Session</div>
        <div
          className="color-brand body-b4-1 cursor-pointer"
          onClick={() => {
            if (isDrawer) {
              dispatch(setIsMiniDashboardOpen(false));
            }
            navigate("/sessions");
          }}
        >
          View All
        </div>
      </Flex>

      {sessionData.length ? (
        <>
          {" "}
          {!isCarousal ? (
            <Row gutter={[16, 16]}>
              {sessionData.map((item, index) => {
                return (
                  <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24} key={index}>
                    <SessionCard item={item} handleJoinSession={handleJoinSession} />
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div style={{ marginBottom: "20px" }}>
              <Slider {...settings}>
                {sessionData.map((item, index) => {
                  console.log("item", item, index, sessionData);
                  return (
                    <SessionCard item={item} handleJoinSession={handleJoinSession} key={index} />
                  );
                })}
              </Slider>
            </div>
          )}
        </>
      ) : (
        <div
          className="conversation no-conversation"
          style={{ height: "100%", maxWidth: "clamp(300px, 50%, 500px)" }}
        >
          <div
            className="session-outer-card"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto 0",
              // card style
              backgroundColor: "#fdfefe",
              borderRadius: "0.5rem",
              padding: "1rem",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              height: "100%",
            }}
          >
            <img
              src="/assets/images/availbility.png"
              style={{
                width: "clamp(100px, 50%, 250px)",
                height: "auto",
                margin: "0 auto",
              }}
            />
            <div className="title-h6" style={{ marginTop: "1rem" }}>
              No Session Available
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SessionCardHoc;
